<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <invited-organizations
        v-model="innerValue"
        :exclude="exclude"
        :error-messages="errors"
        :readonly="readonly"
        :label="label"
        :search-label="searchLabel"
        :required-color="requiredColor"
        :required="required"
        :params="params"
        @change="change" />
  </ValidationProvider>
</template>

<script>
  import InvitedOrganizations from './InvitedOrganizations.vue'
  import { PARTICIPANT_TYPES } from '@/constants/business'

  export default {
    components: {
      InvitedOrganizations
    },
    props: {
      value: {
        type: Array,
        default: () => {
          return []
        }
      },
      exclude: {
        type: Array,
        default: () => {
          return []
        }
      },
      rules: [String, Object],
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      vid: {
        type: String,
        default: null
      },
      searchLabel: {
        type: String,
        default: ''
      },
      params: {
        type: Object,
        default: () => ({
          participantType: PARTICIPANT_TYPES.PARTICIPANT
        })
      }
    },
    data () {
      return {
        innerValue: null
      }
    },
    computed: {
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') && !!this.rules.length && this.rules.includes('required'))
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newVal) {
          if (newVal !== this.innerValue) {
            this.innerValue = newVal
          }
        }
      },
      innerValue (val) {
        this.$emit('input', val)
      }
    },
    methods: {
      change: function (organizations) {
        this.$emit('change', organizations)
      }
    }
  }
</script>
